import { render, staticRenderFns } from "./FcmNotification.vue?vue&type=template&id=c8995ed0"
import script from "./FcmNotification.vue?vue&type=script&lang=js"
export * from "./FcmNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports